import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field--date__wrapper" }
const _hoisted_2 = {
  class: "custom-select-wrapper position-relative month-wrapper",
  "cy-data": "month"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "field--date",
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setFocusOnDateField && _ctx.setFocusOnDateField(...args)))
  }, [
    _createElementVNode("div", {
      class: "field--date__label",
      style: _normalizeStyle({ opacity: _ctx.isLabelShown ? 1 : 0 })
    }, _toDisplayString(_ctx.label), 5),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Field, {
        modelValue: _ctx.day,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.day = $event)),
        type: "text",
        "max-length": 2,
        name: _ctx.name,
        placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.day`),
        "handles-error": false,
        "is-validated": false,
        "cy-data": "day",
        "handles-data-preload": false,
        "only-numbers": true,
        "is-numeric": true,
        onBlur: _ctx.onDayBlur
      }, null, 8, ["modelValue", "name", "placeholder", "onBlur"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Select, {
          key: _ctx.i18nKey,
          modelValue: _ctx.month,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.month = $event)),
          name: _ctx.name,
          "item-list": _ctx.months,
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.month`),
          "is-validated": false,
          "handles-data-preload": false
        }, null, 8, ["modelValue", "name", "item-list", "placeholder"])
      ]),
      _createVNode(_component_Field, {
        modelValue: _ctx.year,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.year = $event)),
        type: "text",
        class: "input-wrapper--year-of-birth",
        name: _ctx.name,
        "max-length": 4,
        placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.year`),
        "handles-error": false,
        "is-validated": false,
        "cy-data": "year",
        "handles-data-preload": false,
        "only-numbers": true,
        "is-numeric": true,
        onBlur: _ctx.onBlur
      }, null, 8, ["modelValue", "name", "placeholder", "onBlur"])
    ])
  ]))
}